!<!--  -->
<template>
  <div class>
    <div class style="padding:30px;">
      <!-- 修改密码 -->
      <div class>
        <div class>
          <span
            style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #343434;"
          >{{$t('i18n_account_management')}}</span>
        </div>
        <div class>
          <span
            style="font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #343434;line-height: 51px;"
          >{{$t('i18n_change_password')}}</span>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:40px;color:#999999"
            >{{$t('i18n_old_password')}}</span>
            <el-input :placeholder="addPls('i18n_old_password', 'input')" clearable show-password v-model="oldPwd" style="float:left;width:400px"></el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:40px;color:#999999"
            >{{$t('i18n_new_password')}}</span>
            <el-input :placeholder="addPls('i18n_new_password', 'input')" clearable show-password  v-model="newPwd" style="float:left;width:400px"></el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:24px;color:#999999"
            >{{$t('i18n_confirm_password')}}</span>
            <el-input :placeholder="addPls('i18n_confirm_password', 'input')" clearable show-password  v-model="newPwdConfirm" style="float:left;width:400px"></el-input>
          </div>
        </div>

        <el-button
          @click="submit"
          type="primary"
        >{{$t('i18n_confirm_edit')}}</el-button>
      </div>
      <!-- 修改手机 -->
      <div class>
        <div class style="height:30px">
          <!-- <span style="font-size: 24px;font-family: PingFang SC;font-weight: bold;color: #343434;">用户管理</span> -->
        </div>
        <div class>
          <span
            style="font-size: 18px;font-family: PingFang SC;font-weight: 500;color: #343434;line-height: 51px;"
          >{{$t('i18n_change_contact_number')}}</span>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:40px;color:#999999"
            >{{$t('i18n_old_contact_number')}}</span>
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 500; color: #333333; line-height: 40px;"
            >{{phoneNo}}</span>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:56px;color:#999999"
            >{{$t('i18n_new_contact_number')}}</span>
            <el-input :placeholder="$t('i18n_new_contact_number')" v-model="newPhone" style="float:left;width:400px">
              <template slot="prepend">+86</template>
            </el-input>
          </div>
          <div class="block" style="margin-bottom:20px">
            <span
              style="font-size: 16px; font-family: PingFang SC; font-weight: 400; color: #9A9A9A;float:left;line-height:40px;margin-right:70px;color:#999999"
            >{{$t('i18n_verification_code')}}</span>
            <el-input :placeholder="$t('i18n_verification_code')" v-model="code" style="float:left;width:400px">
              <el-button @click="sendCode" slot="append">{{countDown > 0 ? countDown : $t('i18n_Receive_SMS_verification_code')}}</el-button>
            </el-input>
          </div>
        </div>

        <el-button @click="submitPhone"
         type="primary"
        >{{$t('i18n_confirm_edit')}}</el-button>

      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { addPls } from '@/utils/placeholderI18n'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      phone: "",
      // password: "123",
      // username: "test_0006",
    //   密码修改
      newPwd: "",
      newPwdConfirm: "",
      oldPwd: "",
      userInfo:{},
      countDown: 0,
    //   修改手机号
      phone: "",
      newPhone: "",
      code: "",
      phoneNo:""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch:{
			countDown(val){
				if(val <= 0){
					clearInterval(this.timer)
				}
			}
		},
  //方法集合
  methods: {
        // 修改手机号
      submitPhone() {
				if (!this.code || !this.newPhone){
                    this.$message.info(this.$t("i18n_code_or_phone_empty"));
                    return
                }
				if (!(/^1[3456789]\d{9}$/.test(this.newPhone))) {
					 this.$message.info(this.$t("i18n_phone_error"));
                    return
                }
                let user = sessionStorage.getItem("Authorization");
                    user = JSON.parse(user);

				this.$http.post('user/updateUserPhoneNo',  qs.stringify({
					'phoneNo': this.newPhone,
					'smsCode': this.code

				}), {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
				}).then(res => {
					if (res.data.code !== 200){
                        this.$message.info( res.data.message);
                        return
                    }
          this.userInfo.phoneNo = res.data.data
          sessionStorage.setItem('Authorization',JSON.stringify(this.userInfo))
          this.phoneNo = res.data.data
					this.$message.info(this.$t("i18n_change_phone_success"));
					this.newPhone = ''
					this.code = ''
					// setTimeout(function() {
					// 	uni.navigateBack({
					// 		delta: 1
					// 	});
					// }, 1200);
				}).catch(res => {
					console.log(res)
				})
			},


    // 发送验证码
    sendCode() {

      if (this.countDown != 0) {
        this.$message.info(this.$t("i18n_Please_send_again_after_second", {countDown: this.countDown}));

        return;
      }

      if (!/^1[3456789]\d{9}$/.test(this.newPhone)) {
        this.$message.info(this.$t("i18n_phone_error"));
        return false;
      }

      // if (this.phone == this.newPhone) return uni.showToast({
      // 	title: '手机号不能一样！',
      // 	icon: 'none'
      // });

      // if (!this.phone || !this.newPhone) return uni.showToast({
      // 	title: '请输手机号码',
      // 	icon: "none"
      // });
      if (!this.newPhone) {
        this.$message.info(this.addPls("i18n_Phone_number", 'input'));
        return;
      }
       let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      this.$http
        .get(
          "user/requestRegisterSmsCode/" + this.newPhone,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              token: user.token,
            },
          }
        )
        .then((res) => {
          if (res.data.code !== 200){
            this.$message.info(res.data.message);
            return
          }
         this.$message.info("发送成功！");
          if (this.countDown > 0) {
            return;
          }

          clearInterval(this.timer);

          this.countDown = 3;
          this.timer = setInterval(() => {
            this.countDown--;
            console.log(this.countDown)
          }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },

    //   密码修改
    submit() {
      if (!this.newPwd || !this.newPwdConfirm || !this.oldPwd) {
        return this.$message.info(this.$t("i18n_password_cannot_empty"));
      }

      if (this.newPwd != this.newPwdConfirm) {
        return this.$message.info(this.$t("i18n_Confirm_password_different"));
      }
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);

      this.axios
        .post(
          "user/updatePwd",
          qs.stringify({ newPwd: this.newPwd, oldPwd: this.oldPwd }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          console.log(res);
          if (res.data.code != 200) {
            this.$message.info(res.data.message);
            return;
          }

          this.$message.info(this.$t("i18n_edit") + res.data.message + "");
          this.oldPwd = ''
          this.newPwd = ''
          this.newPwdConfirm = ''
          // 清除token

          // setTimeout(function() {
          // 	uni.clearStorageSync()

          // 	uni.reLaunch({
          // 		url: '../user/mydata',

          // 		// complete() {
          // 		// 	this.loadin = false
          // 		// 	uni.showToast({
          // 		// 		title: '退出成功！'
          // 		// 	});
          // 		// }
          // 	})
          // }, 1000);
        })
        .catch((res) => {
          console.log(res);
        });
    },
    addPls,
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
     let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      this.userInfo = user
      this.phoneNo = user.phoneNo
  },
};
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.block {
  float: left;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/PersonalCenter/accountManage/UserManage.vue